import ApiService from "./ApiService";

class PostponeController {
  constructor() {
    this.apiService = new ApiService();
  }

  /**
   * Get all postpone requests
   * @returns {Promise<Object[]>}
   */
  async getAll() {
    return this.apiService.get("postpone");
  }

  /**
   * Get a postpone request by ID
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async getById(requestId) {
    return this.apiService.get(`postpone/${requestId}`);
  }

  /**
   * Get open requests for a team
   * @param {string} teamId
   * @returns {Promise<Object[]>}
   */
  async getOpenRequests(teamId) {
    return this.apiService.get(`postpone/open?teamID=${teamId}`);
  }

  /**
   * Create a new postpone request
   * @param {string} matchId
   * @param {Object} requester - { id: string, teamName: string }
   * @param {Object} requestee - { id: string, teamName: string }
   * @returns {Promise<Object>}
   */
  async createNewRequest(matchId, requester, requestee) {
    const sanitizeTeam = (team) => ({
      id: team.id || null,
      sid: team.sid || "",
      logo: team.logo || "",
      teamName: team.teamName || "",
    });

    const requestBody = {
      match: { id: matchId },
      requester: sanitizeTeam(requester),
      requestee: sanitizeTeam(requestee),
      response: null,
      status: false,
      responseDate: null,
    };

    return this.apiService.post("postpone", requestBody);
  }

  /**
   * Approve a postpone request
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async approveRequest(requestId) {
    return this.apiService.post(`postpone/${requestId}/approve`);
  }

  /**
   * Deny a postpone request
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async denyRequest(requestId) {
    return this.apiService.post(`postpone/${requestId}/deny`);
  }

  /**
   * Toggle a postpone request's status
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async toggleStatus(requestId) {
    return this.apiService.post(`postpone/${requestId}/toggle`);
  }

  /**
   * Update a postpone request
   * @param {string} requestId
   * @param {Object} partialUpdate - any field(s) to patch
   * @returns {Promise<Object>}
   */
  async updateRequest(requestId, partialUpdate) {
    return this.apiService.patch(`postpone/${requestId}`, partialUpdate);
  }

  /**
   * Delete a postpone request
   * @param {string} requestId
   * @returns {Promise<void>}
   */
  async deleteRequest(requestId) {
    return this.apiService.delete(`postpone/${requestId}`);
  }

  /**
   * Create multiple postpone requests
   * @param {Object[]} requests
   * @returns {Promise<Object[]>}
   */
  async createBatch(requests) {
    return this.apiService.post("postpone/batch", requests);
  }

  /**
   * Update multiple postpone requests
   * @param {Object[]} updates
   * @returns {Promise<Object[]>}
   */
  async updateBatch(updates) {
    return this.apiService.patch("postpone/batch", updates);
  }
}

export default PostponeController;
